import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export interface FormContext {
  customizationFields: CustomizationField[]
}

export const VendorSchema = ({ customizationFields }: FormContext) => {
  return z.object({
    merchantName: z
      .string()
      .optional()
      .nullable()
      .refine(
        (merchantName) =>
          isMandatory('merchant_name', 'expense', customizationFields) ? !!merchantName : true,
        defaultRequiredMessage()
      ),
    merchantTin: z
      .string()
      .optional()
      .nullable()
      .refine(
        (merchantTin) =>
          isMandatory('merchant_tin', 'expense', customizationFields) ? !!merchantTin : true,
        defaultRequiredMessage()
      ),
  })
}
export type VendorSchema = z.infer<ReturnType<typeof VendorSchema>>
